import { useValidateToken } from '@/hooks';
import { TokenPage } from '@workspace/auth';

export default function DealsTokenPage() {
    return <TokenPage useValidateTokenHook={useValidateToken} />;
}
